// extracted by mini-css-extract-plugin
export default {"root":"d48bm__root","tooltipInner":"LQk90__tooltipInner","headerTooltipValue":"VL67L__headerTooltipValue"};